export default __webpack_public_path__ + "static/media/nodejs.b0d6c7ce.svg";